export function getLastUsedTimeForSubaccount(
  subaccountId: string
): number | null {
  return Number(
    localStorage.getItem(`lastUsedTimeForSubaccount:${subaccountId}`)
  );
}

export function getLastUsedSubaccountId(): string | null {
  return localStorage.getItem("lastUsedSubaccountId");
}

export function setLastUsedTimeForSubaccount(subaccountId: string): void {
  localStorage.setItem(
    `lastUsedTimeForSubaccount:${subaccountId}`,
    Date.now().toString()
  );
  localStorage.setItem("lastUsedSubaccountId", subaccountId);
}
